import type { ReactNode } from 'react';

interface MobileCardListProps<T> {
  data: T[];
  renderCard: (item: T, index: number) => ReactNode;
  loading?: boolean;
  emptyMessage?: string;
  skeletonCount?: number;
}

function CardSkeleton() {
  return (
    <div className="bg-[var(--color-surface)] rounded-lg border border-[var(--color-border)] p-3 animate-pulse">
      <div className="flex gap-3">
        <div className="w-12 h-12 rounded bg-[var(--color-border-light)] shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-[var(--color-border-light)] rounded w-3/4" />
          <div className="h-3 bg-[var(--color-border-light)] rounded w-1/2" />
          <div className="h-3 bg-[var(--color-border-light)] rounded w-1/3" />
        </div>
      </div>
    </div>
  );
}

export function MobileCardList<T>({
  data,
  renderCard,
  loading,
  emptyMessage = 'Sin datos',
  skeletonCount = 5,
}: MobileCardListProps<T>) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: skeletonCount }, (_, i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="text-center py-12 text-[var(--color-text-muted)] text-sm">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {data.map((item, idx) => renderCard(item, idx))}
    </div>
  );
}
